<template>
  <b-overlay
    :show="load"
    rounded="sm"
  >
    <b-row class="mx-3 mb-1">
      <b-col cols="4">
        <label>Tipo de alumno</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="tipoAlumno"
          :options="options"
          class="w-100"
          :reduce="val => val.item"
          label="name"
          :clearable="false"
          placeholder="Seleccione filtro"
          @input="(val) => $emit('update:tipoAlumno', val)"
        />
      </b-col>
      <!-- <b-col cols="3">
        <label>Con agenda</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="agendaFilter"
          :options="agendaOptions"
          class="w-100"
          :reduce="val => val.value"
          placeholder="Seleccione filtro"
          @input="(val) => $emit('update:agendaFilter', val)"
        />
      </b-col> -->
      <b-col cols="4">
        <label>Orden ACT o AUT para este plan</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="ordenFilter"
          :options="ordenOptions"
          class="w-100"
          :reduce="val => val.value"
          placeholder="Seleccione filtro"
          @input="(val) => $emit('update:ordenFilter', val)"
        />
      </b-col>
      <b-col cols="4">
        <label>Nivel</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="nivelFilter"
          :options="nivelOptions"
          class="w-100"
          :reduce="val => val.orden"
          label="orden"
          placeholder="Seleccione filtro"
          @input="(val) => $emit('update:nivelFilter', val)"
        />
      </b-col>
    </b-row>

  </b-overlay>
</template>

<script>
import {
  BRow,
  BCol,
  BOverlay,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    vSelect,
    BOverlay,
  },
  props: {
    agendaFilter: {
      type: [Number, null],
      default: null,
    },
    agendaOptions: {
      type: Array,
      required: true,
    },
    ordenFilter: {
      type: [Number, null],
      default: null,
    },
    ordenOptions: {
      type: Array,
      required: true,
    },
    nivelOptions: {
      type: Array,
      required: true,
    },
    nivelFilter: {
      type: [Number, null],
      default: null,
    },
    load: {
      type: Boolean,
      default: false,
    },
    tipoAlumno: {
      type: [String, null],
      default: null,
    },
  },
  setup() {
    const options = [
      { item: 'RB', name: 'Alumnos Regulares con beca' },
      { item: 'RO', name: 'Alumnos Regulares S/B o con %' },
      { item: 'RP', name: 'Alumnos Irregulares Recursamiento' },
      { item: 'BA', name: 'Alumnos con Baja' },
    ]

    return {
      options,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
